import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { styled } from '@mui/material/styles';
import loadScript from '../utils/loadScript';
import AdDisplay from './AdDisplay';
import { adBodyImageStyles } from './ad.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CarbonRoot = styled('span')(function (_ref) {
  var theme = _ref.theme;
  var styles = adBodyImageStyles(theme);
  return {
    width: '100%',
    '& > div': {
      // The isolation logic of carbonads is broken.
      // Once the script starts loading, it will asynchronous resolve, with no way to stop it.
      // This leads to duplication of the ad.
      //
      // To solve the issue, we only display the #carbonads div
      display: 'none'
    },
    '& #carbonads': _extends({}, styles.root, {
      '& .carbon-img': styles.imgWrapper,
      '& img': styles.img,
      '& a, & a:hover': styles.a,
      '& .carbon-text': styles.description,
      '& .carbon-poweredby': styles.poweredby
    })
  };
});
function AdCarbonImage() {
  var ref = React.useRef(null);
  React.useEffect(function () {
    // The isolation logic of carbonads is broken.
    // Once the script starts loading, it will asynchronous resolve, with no way to stop it.
    // This leads to duplication of the ad.
    //
    // To solve the issue, for example StrictModel double effect execution, we debounce the load action.
    var load = setTimeout(function () {
      // The DOM node could have unmounted at this point.
      if (!ref.current) {
        return;
      }
      var script = loadScript('https://cdn.carbonads.com/carbon.js?serve=CKYIL27L&placement=material-uicom', ref.current);
      script.id = '_carbonads_js';
    });
    return function () {
      clearTimeout(load);
    };
  }, []);
  return /*#__PURE__*/_jsx(CarbonRoot, {
    ref: ref
  });
}
export function AdCarbonInline() {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    ad = _React$useState2[0],
    setAd = _React$useState2[1];
  React.useEffect(function () {
    var active = true;
    var attempt = 0;
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var tryFetch, _tryFetch, sanitizedAd;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _tryFetch = function _tryFetch3() {
              _tryFetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var response, data, sanitizedAd;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(attempt >= 10 || !active)) {
                        _context.next = 2;
                        break;
                      }
                      return _context.abrupt("return", null);
                    case 2:
                      attempt += 1;
                      _context.prev = 3;
                      _context.next = 6;
                      return fetch('https://srv.buysellads.com/ads/CE7DC23W.json');
                    case 6:
                      response = _context.sent;
                      _context.next = 12;
                      break;
                    case 9:
                      _context.prev = 9;
                      _context.t0 = _context["catch"](3);
                      return _context.abrupt("return", null);
                    case 12:
                      _context.next = 14;
                      return response.json();
                    case 14:
                      data = _context.sent;
                      // Inspired by https://github.com/Semantic-Org/Semantic-UI-React/blob/2c7134128925dd831de85011e3eb0ec382ba7f73/docs/src/components/CarbonAd/CarbonAdNative.js#L9
                      sanitizedAd = data.ads.filter(function (item) {
                        return Object.keys(item).length > 0;
                      }).filter(function (item) {
                        return item.statlink;
                      }).filter(Boolean)[0];
                      if (sanitizedAd) {
                        _context.next = 18;
                        break;
                      }
                      return _context.abrupt("return", tryFetch());
                    case 18:
                      return _context.abrupt("return", sanitizedAd);
                    case 19:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[3, 9]]);
              }));
              return _tryFetch.apply(this, arguments);
            };
            tryFetch = function _tryFetch2() {
              return _tryFetch.apply(this, arguments);
            };
            _context2.next = 4;
            return tryFetch();
          case 4:
            sanitizedAd = _context2.sent;
            if (active) {
              setAd(sanitizedAd);
            }
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
    return function () {
      active = false;
    };
  }, []);
  return ad ? /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx("img", {
      src: ad.statimp,
      alt: "",
      style: {
        display: 'none'
      }
    }), ad.pixel && ad.pixel.split('||').map(function (pixel, i) {
      return /*#__PURE__*/_jsx("img", {
        src: "".concat(pixel.replace('[timestamp]', ad.timestamp)),
        style: {
          display: 'none'
        },
        alt: ""
      }, i);
    }), /*#__PURE__*/_jsx(AdDisplay, {
      className: "carbonads",
      shape: "inline",
      ad: {
        link: ad.statlink,
        img: ad.image,
        name: ad.company,
        descriptionHeader: ad.company,
        description: ad.description,
        poweredby: 'Carbon',
        label: 'carbon-demo-inline'
      }
    })]
  }) : /*#__PURE__*/_jsx("div", {
    style: {
      minHeight: 52
    }
  });
}
export default function AdCarbon() {
  return /*#__PURE__*/_jsx(AdCarbonImage, {});
}